import { CARGAR_CONFIGURACION_EXITO } from './actions';

export const configuracion = (state = {}, action) => {
  switch (action.type) {
    case CARGAR_CONFIGURACION_EXITO:
      return {
        ...state,
        ...action.configuracion,
      };
    default:
      return state;
  }
};
